<template>
  <meta
    content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
    name="viewport"
  />
  <div id="app">
    <router-view v-slot="{ Component }">
      <keep-alive :max="5">
        <component :is="Component" v-if="$route.meta.keepAlive" />
      </keep-alive>
      <component :is="Component" v-if="!$route.meta.keepAlive" />
    </router-view>
  </div>
</template>
<script>
export default {
  created() {
    let isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      //在页面刷新时将vuex里的信息保存到缓存里
      window.addEventListener("pagehide", () => {
        localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
      });
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("messageStore") &&
        this.$store.replaceState(
          Object.assign(
            this.$store.state,
            JSON.parse(localStorage.getItem("messageStore"))
          )
        );
    } else {
      //在页面刷新时将vuex里的信息保存到缓存里
      window.addEventListener("beforeunload", () => {
        localStorage.setItem("messageStore", JSON.stringify(this.$store.state));
      });
      //在页面加载时读取localStorage里的状态信息
      localStorage.getItem("messageStore") &&
        this.$store.replaceState(
          Object.assign(
            this.$store.state,
            JSON.parse(localStorage.getItem("messageStore"))
          )
        );
    }
  },
};
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
</script>

<style>
#app {
  font-family: PingFangSC-Medium, Helvetica, Arial, sans-serif ;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body {
  background: #f1f2f3;
}
.top-margin {
  padding-top: 45px;
}
.container {
  height: auto;
}

.main-btn {
  width: 100%;
  line-height: 48px;
  height: 48px;
  border-radius: 10px;
}
.arrows-icon {
  width: 10px;
  height: 15px;
}
.m-20 {
  margin: 20px;
}
.r-ab-20 {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.default-icon {
  width: 20px;
  height: 20px;
}
.small-icon {
  width: 15px;
  height: 15px;
}
.display_flex {
  display: flex;
}
.display_column {
  display: flex;
  flex-direction: column;
}
.block {
  border-radius: 5px;
  padding: 2px 2px 0px 2px;
  font-size: 10px;
}
.text-delete {
  text-decoration: line-through;
}
.font-bold {
  font-weight: bold;
}
.t-f20-c1a {
  font-size: 20px;
  color: #1a1a1a;
}
.t-f16-cff {
  font-size: 16px;
  color: #fff;
}
.t-f16-c1a {
  font-size: 16px;
  color: #1a1a1a;
}
.t-f14-c1a {
  font-size: 14px;
  color: #1a1a1a;
}
.t-f14-c78 {
  font-size: 14px;
  color: #787878;
}

.t-f14-c0082FF {
  font-size: 14px;
  color: #0082ff;
}
.t-f14-cf19321 {
  font-size: 14px;
  color: #f19321;
}
.t-f18-c1a {
  font-size: 18px;
  color: #1a1a1a;
}
.t-f12-c28 {
  font-size: 12px;
  color: #282828;
}
.t-f12-cf19321 {
  font-size: 12px;
  color: #f19321;
}
.t-f12-c0082FF {
  font-size: 12px;
  color: #0082ff;
}
.t-f12-cff8f00 {
  font-size: 12px;
  color: #ff8f00;
}
.t-f12-c1a {
  font-size: 12px;
  color: #1a1a1a;
}
.t-f16-c99 {
  font-size: 16px;
  color: #999;
}
.t-f16-cf19321 {
  font-size: 16px;
  color: #f19321;
}
.t-f12-c99 {
  font-size: 12px;
  color: #999;
}
.t-f12-c66 {
  font-size: 12px;
  color: #666;
}
.t-f13-c66 {
  font-size: 13px;
  color: #666;
}
.t-f14-cff {
  font-size: 14px;
  color: #ffffff;
}
.t-f14-c66 {
  font-size: 14px;
  color: #666;
}
.t-f14-c99 {
  font-size: 14px;
  color: #999;
}
.t-f26-c1a {
  font-size: 26px;
  color: #1a1a1a;
}

.t-f22-cff8f00 {
  font-size: 22px;
  color: #ff8f00;
}
.t-f30-cff {
  font-size: 30px;
  color: #fff;
}
.m-15 {
  margin: 15px;
}
.m-t-5 {
  margin-top: 5px;
}
.m-t-10 {
  margin-top: 10px;
}
.m-t-15 {
  margin-top: 15px;
}
.m-l-15 {
  margin-left: 15px;
}
.m-l-20 {
  margin-left: 20px;
}
.m-l-32 {
  margin-left: 32px;
}
.m-t-20 {
  margin-top: 20px;
}
.m-l-10 {
  margin-left: 10px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-l-r-10 {
  margin: 0px 10px;
}
.m-l-r-5 {
  margin: 0px 5px;
}
.m-5-l-r {
  margin: 0px 5px;
}
.b-r-5 {
  border-radius: 5px;
}
.self_run {
  border: 1px solid #0082ff;
  color: #0082ff;
  flex-shrink: 0;
  height: 15px;
  line-height: 15px;
}
.info {
  border: 1px solid #ff8f00;
  color: #ff8f00;
}
.third_party {
  border: 1px solid #ff8f00;
  color: #ff8f00;
}
.border_none {
  border: none !important;
}
.in_progress {
  color: #f19321 !important;
}
.unpaid {
  color: #fb0006 !important;
}
.paid {
  color: #999999 !important;
}
.closed {
  color: #999999 !important;
}

</style>
